import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { AppRoles } from './core/config/app-roles';

const r = (roles: string[]) => ({ roles });

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./pages/unauthorized/unauthorized').then(m => m.UnauthorizedComponent),
    canActivate: [authGuard]
  },
  {
    path: 'detran-list',
    loadComponent: () => import('./pages/detran/detran-list/detran-list').then(m => m.DetranComponent),
    canActivate: [authGuard],
    data: r([AppRoles.DETRAN])
  },
  {
    path: 'detran-edit/:id',
    loadComponent: () => import('./pages/detran/detran-edit/detran-edit').then(m => m.EditarDetranComponent),
    canActivate: [authGuard],
    data: r([AppRoles.DETRAN])
  },
  {
    path: 'detran-parametro-list',
    loadComponent: () => import('./pages/detran-parametro/detran-parametro-list/detran-parametro-list').then(m => m.DetranParametroListComponent),
    canActivate: [authGuard],
    data: r([AppRoles.PARAMETRO])
  },
  {
    path: 'patio',
    loadComponent: () => import('./pages/patio/patio-list/patio-list').then(m => m.PatioList),
    canActivate: [authGuard],
    data: r([AppRoles.PATIO])
  },
  {
    path: 'patio-edit/:id',
    loadComponent: () => import('./pages/patio/patio-edit/patio-edit').then(m => m.PatioEdit),
    canActivate: [authGuard],
    data: r([AppRoles.PATIO])
  },
  {
    path: 'guincho',
    loadComponent: () => import('./pages/guincho/guincho-list/guincho-list').then(m => m.GuinchoList),
    canActivate: [authGuard],
    data: r([AppRoles.GUINCHO])
  },
  {
    path: 'guincho-edit/:id',
    loadComponent: () => import('./pages/guincho/guincho-edit/guincho-edit').then(m => m.GuinchoEdit),
    canActivate: [authGuard],
    data: r([AppRoles.GUINCHO])
  },
  {
    path: 'marca-modelo',
    loadComponent: () => import('./pages/marca-modelo/marca-modelo-list/marca-modelo-list').then(m => m.MarcaModeloList),
    canActivate: [authGuard],
    data: r([AppRoles.MARCA_MODELO])
  },
  {
    path: 'municipio',
    loadComponent: () => import('./pages/municipio/municipio-list/municipio-list').then(m => m.MunicipioList),
    canActivate: [authGuard],
    data: r([AppRoles.MUNICIPIO])
  },
  {
    path: 'municipio-edit/:id',
    loadComponent: () => import('./pages/municipio/municipio-edit/municipio-edit').then(m => m.MunicipioEdit),
    canActivate: [authGuard],
    data: r([AppRoles.MUNICIPIO])
  },
  {
    path: 'tipo-produto',
    loadComponent: () => import('./pages/tipo-produto/tipo-produto-list/tipo-produto-list').then(m => m.TipoProdutoList),
    canActivate: [authGuard],
    data: r([AppRoles.TIPO_PRODUTO])
  },
  {
    path: 'especie-veiculo',
    loadComponent: () => import('./pages/especie-veiculo/especie-veiculo-list/especie-veiculo-list').then(m => m.EspecieVeiculoList),
    canActivate: [authGuard],
    data: r([AppRoles.ESPECIE_VEICULO])
  },
  {
    path: 'agente-financeiro',
    loadComponent: () => import('./pages/agente-financeiro/agente-financeiro-list/agente-financeiro-list').then(m => m.AgenteFinanceiroList),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_FINANCEIRO])
  },
  {
    path: 'agente-financeiro-edit/:id',
    loadComponent: () => import('./pages/agente-financeiro/agente-financeiro-edit/agente-financeiro-edit').then(m => m.AgenteFinanceiroEdit),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_FINANCEIRO])
  },
  {
    path: 'agente-financeiro-create',
    loadComponent: () => import('./pages/agente-financeiro/agente-financeiro-create/agente-financeiro-create').then(m => m.AgenteFinanceiroCreate),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_FINANCEIRO])
  },
  {
    path: 'agente-financeiro-perfil',
    loadComponent: () => import('./pages/agente-financeiro/perfil/perfil-list/perfil-list').then(m => m.PerfilList),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_FINANCEIRO_PERFIL])
  },
  {
    path: 'perfil-gestao',
    loadComponent: () => import('./pages/agente-financeiro/perfil/perfil-list/perfil-list').then(m => m.PerfilList),
    data: { tipoUsuario: 'GES', ...r([AppRoles.CONFIG_PERFIL]) },
    canActivate: [authGuard]
  },
  {
    path: 'agente-financeiro-usuario',
    loadComponent: () => import('./shared/component/usuario-component/usuarios-list.component').then(m => m.UsuariosListComponent),
    data: { tipoUsuario: 'AGE', ...r([AppRoles.USUARIO_AGENTE_FINANCEIRO]) },
    canActivate: [authGuard]
  },
  {
    path: 'agente-oficial-list',
    loadComponent: () => import('./pages/agente-oficial/agente-oficial-list/agente-oficial-list').then(m => m.AgenteOficialList),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_OFICIAL])
  },
  {
    path: 'agente-oficial-create',
    loadComponent: () => import('./pages/agente-oficial/agente-oficial-form/agente-oficial-form').then(m => m.AgenteOficialFormComponent),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_OFICIAL])
  },
  {
    path: 'agente-oficial-edit/:id',
    loadComponent: () => import('./pages/agente-oficial/agente-oficial-form/agente-oficial-form').then(m => m.AgenteOficialFormComponent),
    canActivate: [authGuard],
    data: r([AppRoles.AGENTE_OFICIAL])
  },
  {
    path: 'usuarios',
    loadComponent: () => import('./pages/usuarios/usuarios').then(m => m.UsuariosComponent),
    canActivate: [authGuard],
  },
  {
    path: 'usuarios-gestao',
    loadComponent: () => import('./shared/component/usuario-component/usuarios-list.component').then(m => m.UsuariosListComponent),
    data: { tipoUsuario: 'gestao', ...r([AppRoles.CONFIG_USUARIO]) },
    canActivate: [authGuard]
  },
  {
    path: 'registro-garantia-envio',
    loadComponent: () => import('./pages/registro-garantia/registro-garantia-envio/registro-garantia-envio').then(m => m.RegistroGarantiasComponent),
    canActivate: [authGuard],
    data: r([AppRoles.WRITE_REGISTRO_GARANTIA])
  },
  {
    path: 'registro-garantia-list',
    loadComponent: () => import('./pages/registro-garantia/registro-garantia-list/registro-garantia-list').then(m => m.RegistroGarantiaList),
    canActivate: [authGuard],
    data: r([AppRoles.REGISTRO_GARANTIA_READ])
  },
  {
    path: 'registro-garantia-edit/:id',
    loadComponent: () => import('./pages/registro-garantia/registro-garantia-edit/registro-garantia-edit').then(m => m.RegistroGarantiaEdit),
    canActivate: [authGuard],
    data: r([AppRoles.WRITE_REGISTRO_GARANTIA])
  },
  {
    path: 'registro-contrato',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'pre-registro',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'averbacao',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'consulta',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'relatorios',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'configuracoes',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];